function initAccessibleFilter({
  container = '.filter-contain',
  itemSelector = '.prod-card',
  filters = [],
  summaryTarget = '#a11y-filter-status',
  clearOnToggle = false,
  toggleButton = '.filter-toggle',
  filterPanel = '.press-on-filter',
  syncURL = true,
  // NEW: "Load More" pagination controls.
  // batchSize = how many unfiltered items to reveal at a time.
  //   null/0 = old behavior (show everything, no Load More).
  // loadMoreButton = selector for the button that reveals the next batch.
  batchSize = null,
  loadMoreButton = '#loadMoreBtn'
}) {
  const $container = $(container);
  const $summary = $(summaryTarget);
  const $toggle = $container.find(toggleButton);
  const $panel = $container.find(filterPanel);
  const $loadMore = $(loadMoreButton);

  // How many *unfiltered* items are currently revealed. Grows each time
  // "Load More" is clicked. Irrelevant while a filter is active (see below).
  let revealCount = batchSize || Infinity;

  // CHANGED: query items live so AJAX-appended cards (loaded past the 250
  // paginate cap) are always included, instead of a frozen init-time set.
  function getItems() {
    return $(itemSelector);
  }

  function filtersActive() {
    return filters.some(f => $container.find(`${f.selector}:checked`).length > 0);
  }

  if ($toggle.length && $panel.length) {
    $toggle.attr('role', 'button').attr('aria-expanded', 'false').attr('tabindex', 0);

    $toggle.on('click keypress', function (e) {
      if (e.type === 'click' || e.key === 'Enter' || e.key === ' ') {
        const expanded = $(this).attr('aria-expanded') === 'true';
        $(this).attr('aria-expanded', !expanded);
        $panel.toggle();
      }
    });
  }

  filters.forEach(f => {
    $container.on('change', f.selector, function () {
      applyFilterLogic();
      if (syncURL) updateURL();
    });
  });

  if ($loadMore.length) {
    $loadMore.on('click', function () {
      revealCount += (batchSize || Infinity);
      applyFilterLogic();
    });
  }

  function getURLKey(f) {
    return f.urlKey || f.dataAttr;
  }

  function updateURL() {
    const params = new URLSearchParams(window.location.search);

    filters.forEach(f => {
      const key = getURLKey(f);
      const $checked = $container.find(`${f.selector}:checked`);

      if ($checked.length === 0) {
        params.delete(key);
      } else {
        const values = $checked.map(function () {
          return $(this).data('id');
        }).get();
        params.set(key, values.join(','));
      }
    });

    const qs = params.toString();
    const newURL = window.location.pathname + (qs ? '?' + qs : '') + window.location.hash;
    window.history.replaceState({ filters: true }, '', newURL);
  }

  function applyFiltersFromURL() {
    const params = new URLSearchParams(window.location.search);

    filters.forEach(f => {
      const key = getURLKey(f);
      if (!params.has(key)) return;

      const ids = (params.get(key) || '').split(',').filter(Boolean);

      $container.find(f.selector).each(function () {
        const id = String($(this).data('id'));
        $(this).prop('checked', ids.includes(id));
      });
    });
  }

  function itemMatchesFilters($item) {
    return filters.every(f => {
      const $checked = $container.find(`${f.selector}:checked`);
      if ($checked.length === 0) return true;

      const selected = new Set(
        $checked.map(function () { return String($(this).data('id')); }).get()
      );

      // A product may carry multiple pipe-delimited values for a dimension
      // (e.g. "Spring|Summer"). Keep it if ANY value matches a selection.
      const raw = $item.data(f.dataAttr);
      const values = String(raw == null ? '' : raw)
        .split('|')
        .map(v => v.trim())
        .filter(Boolean);
      return values.some(v => selected.has(v));
    });
  }

  function applyFilterLogic() {
    const $items = getItems();
    const active = filtersActive();

    // $matches = every item that satisfies the current filter selections,
    // regardless of whether it's been "revealed" via Load More yet — this
    // set is built from the FULL fetched dataset (all background-loaded
    // pages), not just what's currently visible on screen.
    const $matches = $items.filter(function () {
      return itemMatchesFilters($(this));
    });

    $items.hide();

    if (active) {
      // A filter is active: surface every matching product, even ones
      // that haven't been revealed by Load More yet. Pagination doesn't
      // apply while filtering — the person is asking to find something
      // specific, not to browse a page at a time.
      $matches.show();
      $loadMore.hide();
    } else {
      // No filters: respect the paginated reveal count.
      $matches.slice(0, revealCount).show();
      $loadMore.toggle($matches.length > revealCount);
    }

    announceFilters($matches, active);
  }

  function announceFilters($matches, active) {
    $matches = $matches || getItems();
    const totalMatches = $matches.length;
    const shownCount = active ? totalMatches : Math.min(revealCount, totalMatches);

    const descriptions = filters.map(f => {
      const $checked = $container.find(`${f.selector}:checked`);
      if ($checked.length === 0) return null;
      const labels = $checked.map(function () {
        return $(this).siblings('label').text().trim();
      }).get();
      return `${f.label}: ${labels.join(', ')}`;
    }).filter(Boolean);

    const summary = descriptions.length
      ? `Filters applied: ${descriptions.join('. ')}.`
      : 'No filters applied.';

    let result;
    if (totalMatches === 0) {
      result = 'No products match your filter selections.';
    } else if (!active && shownCount < totalMatches) {
      result = `${shownCount} of ${totalMatches} products shown. Select Load More to see additional items.`;
    } else {
      result = `${shownCount} product${shownCount > 1 ? 's' : ''} shown.`;
    }

    $summary.text('');
    setTimeout(() => $summary.text(`${summary} ${result}`), 20);
  }

  if (syncURL) {
    $(window).on('popstate', function () {
      applyFiltersFromURL();
      applyFilterLogic();
    });
  }

  // CHANGED: re-apply once the AJAX loader has appended the rest of the products.
  document.addEventListener('collection:fully-loaded', function () {
    if (syncURL) applyFiltersFromURL();
    applyFilterLogic();
  });

  // Init: read URL → check boxes → filter
  if (syncURL) applyFiltersFromURL();
  applyFilterLogic();
}
